import { $t } from '@/locales'
export default {
  data() {
    return {
      showOrderTips: false,
    }
  },
  computed: {
    companyOrderTips() {
      const map = this.filterCompanyOrder(this.orderList)
      const esignLen = (map.get('esign') && map.get('esign').count) || 0
      this.showOrderTips = this.orderList.length > 1 && this.orderList.length > esignLen

      return [...map.values()].map((v) => $t('{slot1} {slot2} 笔', { slot1: v.companyName, slot2: v.count })).join('，')
    },
  },
  methods: {
    // 按照公司主体过滤归纳订单
    filterCompanyOrder(orderList = []) {
      const res = new Map()
      for (let index = 0; index < orderList.length; index++) {
        const { companyName = '', companyCode = '' } = orderList[index]
        const item = res.get(companyCode)
        res.set(companyCode, { companyName, count: item && item.count ? item.count + 1 : 1 })
      }

      return res
    },
    addCal(a, b) {
      let c, d, e
      try {
        c = a.toString().split('.')[1].length
      } catch (f) {
        c = 0
      }
      try {
        d = b.toString().split('.')[1].length
      } catch (f) {
        d = 0
      }

      return (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) + this.mul(b, e)) / e
    },
    // 乘法运算
    mul(a, b) {
      let c = 0
      const d = a.toString()
      const e = b.toString()
      try {
        c += d.split('.')[1].length
      } catch (f) {}
      try {
        c += e.split('.')[1].length
      } catch (f) {}

      return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
    },
  },
}
